module.exports = __webpack_public_path__ + "static/media/en.c7b12ec1.png";